import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, CanDeactivate, CanLoad, Route, Router, RouterStateSnapshot, UrlSegment, UrlTree } from "@angular/router";
import { LoggedService } from "../services/logged.service";
import { Observable } from "rxjs";
import { Injectable } from "@angular/core";
import { SnackbarService } from "../services/snackbar.service";

@Injectable({
    providedIn: 'root'
})

//Llamar a una funcion que busque los roles a los que se les permite entrar a ruta seleccionada. En la url agregar un parametro que indique qué permisos buscar.
export class AuthGuard { //No se usa


    constructor(private loggedService: LoggedService, private router: Router, snackBarService:SnackbarService) { }

    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        let url: string = state.url;
        return this.checkUserLogin(next, url);
    }
    canActivateChild(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        return this.canActivate(next, state);
    }
    canDeactivate(
        component: unknown,
        currentRoute: ActivatedRouteSnapshot,
        currentState: RouterStateSnapshot,
        nextState?: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        return true;
    }
    canLoad(
        route: Route,
        segments: UrlSegment[]): Observable<boolean> | Promise<boolean> | boolean {
        return true;
    }

    checkUserLogin(route: ActivatedRouteSnapshot, url: any): boolean {
        if (this.loggedService.validToken()) {
            const userRole = this.loggedService.logged.rol;
            if (route.data.role && route.data.role.indexOf(userRole) === -1) {
                this.router.navigate(['']);
                return false;
            }
            return true;
        }

        this.router.navigate(['']);
        return false;
    }
}